var _path, _mask, _g, _mask2, _g2, _path2, _path3, _path4, _circle, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgViewNewOrganization = function SvgViewNewOrganization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 661 576",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F4654",
    d: "M0 0h661v576H0z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "view-new-organization_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 255,
    y: 0,
    width: 406,
    height: 307
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M255 0h406v307H255z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43,
    fill: "#fff",
    mask: "url(#view-new-organization_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M817.813 181.482H468.865A129.192 129.192 0 01598.052 52.351h348.949a129.192 129.192 0 01-129.188 129.131z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M630.512 129.131H281.566A129.193 129.193 0 01410.756 0h348.946a129.18 129.18 0 01-129.19 129.131zM520.014 292H359.51a129.195 129.195 0 0137.853-91.31 129.17 129.17 0 0191.316-37.821h160.504a129.182 129.182 0 01-37.85 91.312A129.163 129.163 0 01520.014 292z"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "view-new-organization_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 292,
    width: 464,
    height: 284
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#C4C4C4",
    d: "M0 292h463.099v284H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#view-new-organization_svg__b)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M206.894 576h-336.101c.013-32.913 13.128-64.475 36.462-87.744 23.333-23.27 54.975-36.343 87.968-36.346h336.11c-.013 32.916-13.129 64.478-36.465 87.748C271.533 562.928 239.889 576 206.894 576zM40.252 434h-337.045c.013-32.915 13.166-64.478 36.567-87.748 23.4-23.27 55.132-36.342 88.218-36.342h337.035a123.527 123.527 0 01-9.502 47.495 124.062 124.062 0 01-27.049 40.261 124.793 124.793 0 01-40.48 26.897A125.31 125.31 0 0140.252 434z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M302.642 496.685H47.334c.013-32.915 13.157-64.478 36.541-87.748 23.384-23.27 55.094-36.342 88.157-36.342H427.28a123.512 123.512 0 01-9.466 47.497 123.969 123.969 0 01-27.015 40.268 124.606 124.606 0 01-40.447 26.898 125.055 125.055 0 01-47.71 9.427z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3E50",
    stroke: "#fff",
    strokeWidth: 5,
    strokeLinejoin: "round",
    d: "M229 271h77v143h-77z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306 414h85V213h-85v201z",
    fill: "#2C3E50",
    stroke: "#fff",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M247 288h14v14h-14zM247 318h14v14h-14zM247 348h14v14h-14zM247 378h14v14h-14zM278 288h14v14h-14zM278 318h14v14h-14zM278 348h14v14h-14zM278 378h14v14h-14z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 388,
    cy: 409,
    r: 31,
    fill: "#70CE45"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M404 406.967v4.131h-13.967V425h-4.066v-13.902H372v-4.131h13.967V393h4.066v13.967H404z",
    fill: "#fff"
  })));
};

export default SvgViewNewOrganization;